import Identificacion from "../Comun/Identificacion";
import TipoDocumento from "../Comun/TipoDocumento";

export default class DocumentoSolicitudPadron {
  constructor() {
    this.NumeroSolicitud = 0;
    this.Identificacion = new Identificacion();
    this.TipoDocumento = new TipoDocumento();
    this.NombreArchivo = "";
    this.Documento = "";
    this.EsValido = false;
    this.Errores = [];
  }

  NumeroSolicitud?: number;
  Identificacion: Identificacion;
  TipoDocumento: TipoDocumento;
  NombreArchivo: string;
  Documento: string;
  EsValido: boolean;
  Errores: any;
}
